import React from 'react';
import makeLoadable from '@loadable/component';
import RouterLoader from './RouterLoader';
import {routePaths} from './route-paths';
import SmsPermissions from 'pages/sms-permissions';

export function loadable(module) {
    return makeLoadable(module, {fallback: <RouterLoader />});
}

const componentsByPath = {
    '/sms-permissions': SmsPermissions,
};

const routes = routePaths.map(routePath => ({
    ...routePath,
    component: componentsByPath[routePath.path],
}));

export default routes;
